'use client'

import React from 'react'
import { useTravelComparatorStore } from '@/app/stores/travel/travel-comparator.store'
import { destinationOptionsFor, RESIDENCE_OPTIONS, today } from '../travelFormConfig'
import CountryCell from './CountryCell'
import TravelDateRangeField from './TravelDateRangeField'
import TravelersCell from './TravelersCell'

export default function TravelTripFields() {
    const { form, patchForm } = useTravelComparatorStore()

    return (
        <div className="flex flex-col gap-2.5 sm:gap-3">
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 sm:gap-3">
                <CountryCell
                    label="Pays de résidence"
                    placeholder="Votre pays"
                    value={form.residenceCountry}
                    options={RESIDENCE_OPTIONS}
                    onChange={(code) => patchForm({ residenceCountry: code })}
                />
                <CountryCell
                    label="Destination"
                    placeholder="Où allez-vous ?"
                    multiple
                    value={form.destinationCountries}
                    options={destinationOptionsFor(form.motif)}
                    onChange={(codes) => patchForm({ destinationCountries: codes })}
                />
            </div>
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 sm:gap-3">
                <TravelDateRangeField
                    startDate={form.startDate}
                    endDate={form.endDate}
                    minDate={today()}
                    onChange={(startDate, endDate) => patchForm({ startDate, endDate })}
                />
                <TravelersCell />
            </div>
        </div>
    )
}
